import { Box, Button, Grid, TextField } from "@mui/material";
import {
  BusinessUnitSelect,
  ExecutiveChefEmailSelect,
  FormDetailsSelect,
  HODDepartmentSelect,
} from "./";
import {
  CustomMUIDatePickerWithErrors,
  useAuthInfo,
  useFormDropdownFields,
} from "../../../common";
export function EditSampleRequestDetailsForm({
  handleSubmit,
  handleSelect,
  errors,
}) {
  // Get lists of executive chefs and HODs from the management list

  const {
    executiveChefList = [],
    hodList = [],
    endUserLocations = [],
    buNumbers = [],
  } = useFormDropdownFields();

  // Hook to get the authenticated user's information
  const decoded = useAuthInfo();
  return (
    <Box
      component="form"
      noValidate
      onSubmit={handleSubmit}
      sx={{
        mt: 5,
      }}
    >
      {/* Form fields and Autocomplete components for selecting values */}
      <Grid container spacing={2}>
        {decoded.role === "procurement" && (
          <Grid item xs={12} sm={12}>
            <TextField
              name="email"
              fullWidth
              id="email"
              label="Chef Email"
              error={errors && errors.email && true}
              helperText={errors && errors.email !== "" ? errors.email : ""}
            />
          </Grid>
        )}
        {/* Autocomplete components for selecting values */}
        {[
          {
            id: "purpose",
            options: [
              "Alternative product",
              "New Item",
              "Tender",
              "Presentation",
            ],
          },
          { id: "endUserLocation", options: endUserLocations },
        ].map((item, index) => {
          return (
            <Grid item xs={12} sm={12} key={index}>
              <FormDetailsSelect
                item={item}
                errors={errors}
                handleSelect={handleSelect}
              />
            </Grid>
          );
        })}
        {/* Render text field for selecting business unit */}
        <Grid item xs={12} sm={12}>
          <BusinessUnitSelect
            handleSelect={handleSelect}
            buNumbers={buNumbers}
            errors={errors}
          />
        </Grid>
        {/* Textfield prefilled with requester/user email and disabled if requester/user is executive chef  */}
        {decoded?.role === "executiveChef" ? (
          <Grid item xs={12} sm={12}>
            <TextField
              disabled={true}
              name="executiveChefEmail"
              value={decoded.email}
              label="Executive Chef Email"
              variant="filled"
              required
              fullWidth
              id="executiveChefEmail"
              error={errors && errors.fullName && true}
              helperText={
                errors && errors.fullName !== "" ? errors.fullName : ""
              }
            />
          </Grid>
        ) : (
          <Grid item xs={12} sm={12}>
            {/* Otherwise render a autocomplete select component for selecting executive chef */}
            <ExecutiveChefEmailSelect
              handleSelect={handleSelect}
              executiveChefList={executiveChefList}
              errors={errors}
            />
          </Grid>
        )}
        {/* Autocomplete to select HOD Department */}
        <Grid item xs={12} sm={12}>
          <HODDepartmentSelect
            handleSelect={handleSelect}
            hodList={hodList}
            errors={errors}
          />
        </Grid>
        {/* Date select component */}
        <Grid item xs={12} sm={12}>
          <CustomMUIDatePickerWithErrors
            name={"needByDate"}
            shouldDisableWeekends={true}
            shouldHaveMinDate={true}
            errors={errors}
          />
        </Grid>
      </Grid>

      <Button
        type="submit"
        variant="contained"
        sx={{
          mt: 3,
          mb: 6,
          float: "right",
        }}
      >
        Save
      </Button>
    </Box>
  );
}
